<template lang="html">
    <div id="account">
        <header>
            Venue Details
            <router-link :to="{ name: 'Account' }"
                ><chevron-left-icon class="icon"></chevron-left-icon
            ></router-link>
        </header>

        <form class="form">
            <div class="formGroup">
                <p class="help" style="margin-bottom: 0px">
                    Enter the details of the golf club or practice facility where you will be giving
                    lessons
                </p>

                <button
                    v-if="!createOpen && clubs.length === 0"
                    class="button"
                    type="button"
                    @click.prevent="addVenue"
                >
                    Add venue
                    <img class="plus" src="@/assets/plus-white.svg" />
                </button>
            </div>

            <club-item
                v-for="club in clubs"
                :key="club.id"
                :venue="club"
                @openCreate="clubCancelled"
                @clubDeleted="deleteClub"
                @clubUpdated="updateClub"
                @clubAdded="addClub"
            />
        </form>
    </div>
</template>

<script>
import ClubItem from "@/views/Account/components/club-item";
import { ChevronLeftIcon } from "vue-feather-icons";
export default {
    name: "subscription",
    components: { ChevronLeftIcon, ClubItem },
    data() {
        return {
            createOpen: false,
            clubs: [],
        };
    },
    created() {
        this.getClubs();
    },
    methods: {
        getClubs() {
            window.axios.get("/club").then((response) => {
                this.clubs = response.data;
            });
        },
        deleteClub($club) {
            var index = this.clubs.findIndex((club) => {
                return $club.id == club.id;
            });

            this.clubs.splice(index, 1);
        },
        updateClub($club) {
            var index = this.clubs.findIndex((club) => {
                return $club.id == club.id;
            });

            this.clubs.splice(index, 1, $club);
        },
        addClub($club) {
            this.clubs.push($club);
        },
        addVenue() {
            this.clubs.unshift({
                id: false,
                user_id: this.$store.state.user.id,
                name: "",
                address: "",
                telephone: "",
                website: "",
            });
            this.createOpen = true;
        },
        clubCancelled(venue) {
            if (!venue.id) {
                this.clubs.splice(0, 1);
            }
            this.createOpen = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.intro {
    padding: 20px;
    .help {
        line-height: 1.5;
        margin-bottom: 20px;
    }
}
.plus {
    float: right;
}
</style>
